
    <h2 mat-dialog-title >
       <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
        Add {{ContactName}}/Role/User
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
  <mat-dialog-content class="mat-typography">   
    <div class="radOpts" >
      <mat-radio-group aria-label="Select an option" color="primary">
        <mat-radio-button value="1" [checked]=true (click)="selectSharedAccessRb(1)">{{ContactName}}</mat-radio-button>
        <mat-radio-button value="2" (click)="selectSharedAccessRb(2)">Role</mat-radio-button>
        <mat-radio-button value="3" (click)="selectSharedAccessRb(3)">User</mat-radio-button>
      </mat-radio-group>
    </div>

    <app-contactlist *ngIf="!isSharedAccessRolePopup && isSharedAccessUserPopup==false" [objectList]="contactsList" [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="contactSelected($event)" (NotifyListfetch)="getContactListCoreImplementation($event)"></app-contactlist>
    <app-contactlist *ngIf="isSharedAccessRolePopup && isSharedAccessUserPopup==false" [objectList]="sharedAccessRoleList" [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="RoleSelectedForSharedAccess($event)" (NotifyListfetch)="getSharedAccessRoles($event)"></app-contactlist>
    <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="getUserListCoreImplementation($event)"></app-contactlist>
    
    <ul *ngIf="!isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
          <div class="pic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
          </div>
          <div class="detail">
              <h4>{{user.name}}</h4>
              <p>{{user.email}}</p>
          </div>
      </div>
      <div class="option">
        <ng-container *ngFor="let action of getActionType(user.actionType)">
        
          <button mat-flat-button  *ngIf="user.actionType==0"  [matMenuTriggerFor]="menu"  aria-label="Permission">
           <mat-icon>visibility</mat-icon> {{action}}
          </button>
          
          <button mat-flat-button  *ngIf="user.actionType==1"  [matMenuTriggerFor]="menu"  aria-label="Permission">
            <mat-icon>text_fields</mat-icon> {{action}}
          </button>
          
        </ng-container>
        <mat-menu #menu="matMenu" xPosition="before">
          <button (click)="actionSelected('Viewer',0,user.shareToID)"  mat-menu-item>
            <mat-icon>visibility</mat-icon><span>Viewer</span>
          </button>
          <button (click)="actionSelected('Editor',1,user.shareToID)" mat-menu-item>
            <mat-icon>text_fields</mat-icon>
            <span>Editor</span>
          </button>
          <button (click)="removeItemContact(user,false)" mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Remove</span>
          </button>
        </mat-menu>
      </div>
      </li>
    </ul>
    
    <ul *ngIf="isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let role of selectedsharedAccessRole">
        <div class="userndetail">
          <div class="detail">
              <h4>{{role.name}}</h4>
          </div>
      </div>
      <div class="option">

        <ng-container *ngFor="let action of getActionType(role.actionType)">        
        <button mat-flat-button  *ngIf="role.actionType==0"  [matMenuTriggerFor]="menu"  aria-label="Permission">
         <mat-icon>visibility</mat-icon> {{action}}
        </button>
        
        <button mat-flat-button  *ngIf="role.actionType==1"  [matMenuTriggerFor]="menu"  aria-label="Permission">
          <mat-icon>text_fields</mat-icon> {{action}}
        </button>    
      </ng-container>

        <mat-menu #menu="matMenu" xPosition="before">
          <button (click)="actionRoleSelected('Viewer',0,role.shareToID)"  mat-menu-item>
            <mat-icon>visibility</mat-icon><span>Viewer</span>
          </button>
          <button (click)="actionRoleSelected('Editor',1,role.shareToID)" mat-menu-item>
            <mat-icon>text_fields</mat-icon>
            <span>Editor</span>
          </button>
          <button (click)="removeRoles(role,true)" mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Remove</span>
          </button>
        </mat-menu>
      </div>
      </li>
    </ul>
    
    <ul *ngIf="isSharedAccessUserPopup ==true" class="selectedlist">
      <li *ngFor="let user of userSelectedList">
        <div class="userndetail">
            <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>


  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>   
    <button mat-flat-button color="primary" [disabled]=!showAddButton
    (click)="FormFolderContactRoleUpdate()">Done
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
   
  
 

  </mat-dialog-actions>

  <br>
  <br>
  <ul class="selectedlist" *ngIf="sharedList.length>0">
     
    <li *ngFor="let user of sharedList">
      <div class="userndetail">
        <div class="pic">
          <img *ngIf="user.imageUrl!='' " src="{{user.imageUrl}}" alt="">
            <span *ngIf="user.imageUrl=='' " class="username">
                {{user.shortName}}
              </span>
        </div>
        <div class="detail">
            <h4>{{user.name}}</h4>
            <p>{{user.email}}</p>
            <p *ngIf="user.shareToType==1">({{ContactName}})</p>
            <p *ngIf="user.shareToType==2">(Role)</p>
            <p *ngIf="user.shareToType==4">(User)</p>           
        </div>
    </div>
    <div class="option">
      <ng-container *ngFor="let action of getActionType(user.permission)">
      
        <button mat-flat-button  *ngIf="user.permission==0"  [matMenuTriggerFor]="menu"  aria-label="Permission">
         <mat-icon>visibility</mat-icon> {{action}}
        </button>
        
        <button mat-flat-button  *ngIf="user.permission==1"  [matMenuTriggerFor]="menu"  aria-label="Permission">
          <mat-icon>text_fields</mat-icon> {{action}}
        </button>
        
        <button mat-flat-button  *ngIf="user.permission==-1"  [matMenuTriggerFor]="menu"  aria-label="Permission">
          <mat-icon>delete</mat-icon> {{action}}
        </button>

      </ng-container>

      <mat-menu #menu="matMenu" xPosition="before">

        <button (click)="actionSelectedShared('Viewer',0,user.shareToID)"  mat-menu-item>
          <mat-icon>visibility</mat-icon><span>Viewer</span>
        </button>

        <button (click)="actionSelectedShared('Editor',1,user.shareToID)" mat-menu-item>
          <mat-icon>text_fields</mat-icon>
          <span>Editor</span>
        </button>

        <button (click)="actionSelectedShared('Remove',-1,user.shareToID)" mat-menu-item>
          <mat-icon>delete</mat-icon>
          <span>Remove</span>
        </button>
       
      </mat-menu>
    </div>
    </li>

    <mat-dialog-actions>
      <button mat-button></button> 
      <button mat-flat-button color="primary" [disabled]=!showUpdateButton
      (click)="FormFolderSharedContactRoleUpdate()">Update
      <mat-icon *ngIf="spinner1"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>     
    </mat-dialog-actions>
  </ul>
